<template>
  <svg
    class="clara-logo"
    :viewBox="VIEW_BOX"
    role="img"
    :aria-label="title"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{{ title }}</title>
    <defs>
      <!-- Id único por instância: dois logos na página compartilhariam o
           gradiente e o segundo herdaria as cores do primeiro. -->
      <linearGradient
        :id="gradientId"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(120.05354,2335.041351,-2335.041351,120.05354,-1141.832505,703.006338)"
        x1="0"
        y1="0"
        x2="1"
        y2="0"
      >
        <stop
          offset="0"
          :stop-color="stops[0]"
        />
        <stop
          offset="1"
          :stop-color="stops[1]"
        />
      </linearGradient>
    </defs>
    <g transform="matrix(1,0,0,1,-601,-1121)">
      <g transform="matrix(0.166592,0,0,0.166592,1211.220548,988.88453)">
        <path
          :fill="`url(#${gradientId})`"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1034,1124C1319.764,1060.553 1367,795 1367,795C1422.51,1085.663 1696,1122 1696,1122C1406.544,1178.644 1366,1453 1366,1453C1294.401,1153.926 1034,1124 1034,1124ZM1560.097,1414.33C1686.271,1386.316 1707.127,1269.066 1707.127,1269.066C1731.636,1397.403 1852.391,1413.447 1852.391,1413.447C1724.587,1438.457 1706.685,1559.593 1706.685,1559.593C1675.072,1427.543 1560.097,1414.33 1560.097,1414.33ZM-1088.96,1836.002C-1131.465,2068.45 -1278.904,2186.667 -1528.619,2186.667C-1827.481,2186.667 -1981.561,2021.961 -1981.561,1697.862C-1981.561,1373.762 -1827.481,1209.056 -1531.276,1209.056C-1285.545,1209.056 -1138.106,1323.288 -1094.273,1545.11L-1247.025,1545.11C-1284.217,1406.969 -1379.853,1333.914 -1531.276,1333.914C-1729.189,1333.914 -1828.81,1456.115 -1828.81,1697.862C-1828.81,1939.608 -1729.189,2061.809 -1528.619,2061.809C-1373.211,2061.809 -1276.247,1984.769 -1243.04,1836.002L-1088.96,1836.002ZM-937.537,2162.758L-937.537,1232.965L-795.411,1232.965L-795.411,2162.758L-937.537,2162.758ZM-153.854,1731.068C-153.854,1619.493 -187.061,1576.988 -309.263,1576.988C-420.838,1576.988 -475.297,1611.524 -475.297,1701.846L-614.766,1701.846C-617.423,1543.782 -513.817,1469.398 -307.934,1469.398C-84.784,1469.398 -15.714,1554.408 -15.714,1744.351L-15.714,2162.758L-123.304,2162.758L-148.541,2092.359C-193.703,2148.147 -264.101,2186.667 -374.348,2186.667C-524.443,2186.667 -637.347,2113.612 -637.347,1971.486C-637.347,1832.017 -531.085,1761.619 -341.141,1758.962C-281.369,1757.634 -217.612,1757.634 -153.854,1754.977L-153.854,1731.068ZM-492.565,1968.83C-492.565,2039.228 -444.747,2081.733 -347.783,2081.733C-209.642,2081.733 -156.511,1990.082 -153.854,1875.85L-153.854,1853.27C-212.299,1855.926 -260.116,1854.598 -303.95,1855.926C-431.464,1858.583 -492.565,1887.805 -492.565,1968.83ZM550.131,1614.18C385.425,1600.897 296.431,1681.922 296.431,1839.987L296.431,2162.758L154.305,2162.758L154.305,1493.307L272.522,1493.307L293.774,1602.226C334.951,1530.499 402.693,1472.055 511.611,1472.055C530.207,1472.055 539.505,1473.383 550.131,1476.04L550.131,1614.18ZM1123.946,1731.068C1123.946,1619.493 1090.74,1576.988 968.538,1576.988C856.963,1576.988 802.504,1611.524 802.504,1701.846L663.035,1701.846C660.378,1543.782 763.984,1469.398 969.866,1469.398C1193.017,1469.398 1262.087,1554.408 1262.087,1744.351L1262.087,2162.758L1154.497,2162.758L1129.259,2092.359C1084.098,2148.147 1013.7,2186.667 903.453,2186.667C753.358,2186.667 640.454,2113.612 640.454,1971.486C640.454,1832.017 746.716,1761.619 936.66,1758.962C996.432,1757.634 1060.189,1757.634 1123.946,1754.977L1123.946,1731.068ZM785.236,1968.83C785.236,2039.228 833.054,2081.733 930.018,2081.733C1068.159,2081.733 1121.29,1990.082 1123.946,1875.85L1123.946,1853.27C1065.502,1855.926 1017.684,1854.598 973.851,1855.926C846.337,1858.583 785.236,1887.805 785.236,1968.83ZM-3057.548,1494.407L-3114.079,1493.858C-3141.011,1494.309 -3165.39,1505.27 -3183.295,1522.766C-3201.725,1540.904 -3213.297,1566.101 -3213.568,1593.997L-3215.532,1796.315C-3216.075,1852.169 -3171.209,1897.849 -3115.419,1898.391L-2919.572,1900.292C-2849.543,1900.972 -2793.271,1958.349 -2793.951,2028.378L-2795.415,2179.177C-2796.095,2249.206 -2853.471,2305.48 -2923.5,2304.8L-3093.587,2303.149C-3163.616,2302.469 -3219.89,2245.091 -3219.21,2175.063L-3217.47,1995.915C-3217.921,1969.049 -3228.882,1944.67 -3246.378,1926.765C-3264.517,1908.27 -3289.712,1896.698 -3317.608,1896.427L-3537.337,1894.294C-3607.366,1893.614 -3663.638,1836.237 -3662.958,1766.208L-3661.494,1615.409C-3660.814,1545.38 -3603.438,1489.106 -3533.409,1489.786L-3313.745,1491.919C-3257.891,1492.461 -3212.146,1447.596 -3211.605,1391.807L-3209.89,1215.248C-3209.21,1145.219 -3151.833,1088.945 -3081.804,1089.625L-2931.004,1091.089C-2928.616,1091.112 -2926.244,1091.202 -2923.889,1091.355L-2913.84,1091.355C-2877.529,1091.355 -2844.649,1106.047 -2820.896,1129.867C-2797.077,1153.62 -2782.385,1186.501 -2782.385,1222.81L-2782.385,1397.372C-2781.672,1424.233 -2770.475,1448.505 -2752.805,1466.239C-2734.49,1484.555 -2709.181,1495.882 -2681.285,1495.882L-2516.109,1495.882L-2516.109,1495.947L-2486.077,1495.947C-2413.78,1495.947 -2355.139,1554.587 -2355.139,1626.884L-2355.139,1769.472C-2355.139,1841.77 -2413.78,1900.344 -2486.077,1900.344L-2516.109,1900.344L-2516.109,1900.409L-2650.929,1900.409C-2687.24,1900.409 -2720.055,1885.651 -2743.874,1861.898C-2767.628,1838.08 -2782.385,1805.2 -2782.385,1768.89L-2782.45,1595.04C-2783.42,1540.089 -2828.34,1495.882 -2883.483,1495.882L-3037.916,1495.882C-3042.058,1495.882 -3046.137,1495.687 -3050.213,1495.3C-3052.679,1495.07 -3055.124,1494.772 -3057.548,1494.407Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
/**
 * Logo da Clara AI. Master em src/assets/brand/clara-logo.svg; aqui inline para
 * o gradiente ser trocavel — o original rende 2,45:1 sobre o heroi escuro do
 * modal, abaixo do minimo de 3:1, e a variante `reverse` sobe para 7,8:1.
 *
 * Geometria e transforms sao copia byte a byte do master: nao edite a mao.
 */
const VARIANTS = {
  brand: ['#115fac', '#98badc'],
  reverse: ['#ffffff', '#98badc']
};

export default {
  name: 'ClaraLogo',

  props: {
    variant: {
      type: String,
      default: 'brand',
      validator: (v) => Object.keys(VARIANTS).includes(v)
    },

    title: {
      type: String,
      default: 'Clara AI'
    }
  },

  data() {
    return { VIEW_BOX: '0 0 919 252' };
  },

  computed: {
    gradientId() {
      return `clara-logo-grad-${this._uid}`;
    },

    stops() {
      return VARIANTS[this.variant] || VARIANTS.brand;
    }
  }
};
</script>

<style scoped>
.clara-logo {
  display: block;
  width: 100%;
  height: auto;
}
</style>
